import React, { useState } from 'react'
import './Login.css'
import logo from '../../assets/logo.png'
import { Link } from 'react-router-dom'
import ErrorMsg from '../ErrorMsg/ErrorMsg'
import Navbar from '../Home/Navbar/Navbar'
import { useAuth } from '../../auth/AuthContext'


const Login = (props) => {
    const { signIn, refreshProfile, firebaseEnabled } = useAuth()
    const [email, setEmail] = useState('')
    const [pass, setPass] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleLogin = async () => {
        if (!firebaseEnabled) {
            setError('Login is unavailable until Firebase is configured.')
            return
        }
        if (!email || !pass) {
            setError('Please enter your email and password.')
            return
        }
        setLoading(true)
        setError('')
        try {
            const user = await signIn(email, pass)
            const updatedProfile = await refreshProfile(user)
            const role = updatedProfile?.role || 'client'
            if (role === 'admin') {
                props.history.push({ pathname: '/admin' })
            } else {
                props.history.push({ pathname: '/appointment' })
            }
        } catch (err) {
            setError(err.message || 'Unable to sign in.')
        } finally {
            setLoading(false)
        }
    }

    const loginByPress = (e) =>{
        if(e.key === 'Enter')
            handleLogin()
      }

    return (
        <div className='register'>
            <Navbar/>
            <div className='login-container'>
                <div className='register-form'>
                    <div className='register-info'>
                        <h1>Login</h1>
                        <img src={logo} alt=''></img>
                    </div>
                    <div className='form-container'> 
                    {error !== '' ?  <ErrorMsg info={error}/>
                        
                        : ''}
                        <p>Email:</p>
                        <input type="email" 
                            placeholder='Email...'
                            className='form-container-input'
                            name='email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <p>Password:</p>
                        <input type="password"
                            placeholder='Password...'
                            className='form-container-input'
                            name='password'
                            value={pass}
                            onChange={(e) => setPass(e.target.value)}
                            onKeyPress={(e) => loginByPress(e)}
                        />
                        <div className='reg-btn-div'>
                            <button onClick={handleLogin} className='reg-submit' disabled={loading}>
                                {loading ? 'Signing in...' : 'Login'}
                            </button>
                        </div> 
                        <div className='new-account-login'>
                            <Link to='/register' className='new-account-link'>
                                Register for an account
                            </Link> 
                        </div>
                        <p className='login-helper'>
                            Techs and admins sign in with your assigned credentials.
                        </p>
                    </div>
                </div>
                <div className='register-img'></div>
            </div>  
        </div>
    )
}

export default Login
